module.exports = __webpack_public_path__ + "img/viajes-paso-2.361657d6.png";